import * as XLSX from "xlsx";

function toRows(rows, columns) {
  return rows.map((r) => {
    const out = {};
    columns.forEach((c) => {
      const v = typeof c.value === "function" ? c.value(r) : r[c.key];
      out[c.label] = v ?? "";
    });
    return out;
  });
}

export function exportCSV(filename, rows, columns) {
  const data = toRows(rows, columns);
  if (data.length === 0) return;
  const headers = Object.keys(data[0]);
  const escape = (v) => {
    const s = String(v ?? "");
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [headers.join(","), ...data.map((row) => headers.map((h) => escape(row[h])).join(","))].join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportExcel(filename, rows, columns, sheetName = "Sheet1") {
  const data = toRows(rows, columns);
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}
